import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line

import AnimationRevealPage from "../helpers/AnimationRevealPage";
import Hero from "components/hero/TwoColumnWithInput";
import Features from "components/features/ThreeColWithSideImage";
import MainFeature from "components/features/TwoColWithButton";
// import MainFeature2 from "components/features/TwoColWithTwoHorizontalFeaturesAndButton";
import FeatureWithSteps from "components/features/TwoColWithSteps";
// import Pricing from "components/pricing/ThreePlans";
import TeamCardGrid from "components/cards/ProfileThreeColGrid";
// import Testimonial from "components/testimonials/TwoColumnWithImageAndRating";
import FAQ from "components/faqs/SingleCol";
import GetStarted from "components/cta/GetStarted";
import Footer from "components/footers/FiveColumnWithBackground";

import educationalInstituteImageSrc from "images/educational-institute.png";
import macHeroScreenshotImageSrc from "images/steps.png";
// import prototypeIllustrationImageSrc from "images/prototype-illustration.svg";
// import { ReactComponent as BriefcaseIcon } from "feather-icons/dist/icons/briefcase.svg";
// import { ReactComponent as MoneyIcon } from "feather-icons/dist/icons/dollar-sign.svg";

export default function MainLandingPage() {
  const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;
  const HighlightedText = tw.span`text-primary-500`;

  return (
    <AnimationRevealPage disabled>
      <Hero roundedHeaderButton={true} />
      <Features
        subheading={<Subheading>Características</Subheading>}
        heading={
          <>
            Nos definen características{" "}
            <HighlightedText>unicas.</HighlightedText>
          </>
        }
        description={
          <>
            Nuestros algoritmos generan dictados variados e ilimitados, de forma
            que nunca te quedaras sin material para entrenar.
          </>
        }
      />
      <MainFeature
        subheading={<Subheading>Instituciones educativas</Subheading>}
        heading={
          <>
            Pusimos especial foco en las{" "}
            <span tw="text-primary-500">Instituciones Educativas.</span>
          </>
        }
        imageSrc={educationalInstituteImageSrc}
        imageBorder={false}
        imageDecoratorBlob={true}
        primaryButtonUrl={"/educational-institutes"}
      />
      <FeatureWithSteps
        subheading={<Subheading>Pasos</Subheading>}
        heading={
          <>
            Comienza <HighlightedText>Ya.</HighlightedText>
          </>
        }
        textOnLeft={false}
        imageSrc={macHeroScreenshotImageSrc}
        imageDecoratorBlob={true}
        decoratorBlobCss={tw`xl:w-40 xl:h-40 opacity-15 -translate-x-1/2 left-1/2`}
      />
      {/* <MainFeature2
          subheading={<Subheading>VALUES</Subheading>}
          heading={
            <>
              We Always Abide by Our{" "}
              <HighlightedText>Principles.</HighlightedText>
            </>
          }
          imageSrc={prototypeIllustrationImageSrc}
          showDecoratorBlob={false}
          features={[
            {
              Icon: MoneyIcon,
              title: "Affordable",
              description:
                "We promise to offer you the best rate we can - at par with the industry standard.",
              iconContainerCss: tw`bg-green-300 text-green-800`,
            },
            {
              Icon: BriefcaseIcon,
              title: "Professionalism",
              description:
                "We assure you that our templates are designed and created by professional designers.",
              iconContainerCss: tw`bg-red-300 text-red-800`,
            },
          ]}
        /> */}
      {/* <Pricing
          subheading={<Subheading>Pricing</Subheading>}
          heading={
            <>
              Reasonable & Flexible <HighlightedText>Plans.</HighlightedText>
            </>
          }
          plans={[
            {
              name: "Personal",
              price: "$17.99",
              duration: "Monthly",
              mainFeature: "For Individuals",
              features: [
                "30 Templates",
                "7 Landing Pages",
                "12 Internal Pages",
                "Basic Assistance",
              ],
            },
            {
              name: "Business",
              price: "$37.99",
              duration: "Monthly",
              mainFeature: "For Small Businesses",
              features: [
                "60 Templates",
                "15 Landing Pages",
                "22 Internal Pages",
                "Priority Assistance",
              ],
              featured: true,
            },
            {
              name: "Enterprise",
              price: "$57.99",
              duration: "Monthly",
              mainFeature: "For Large Companies",
              features: [
                "90 Templates",
                "27 Landing Pages",
                "37 Internal Pages",
                "Personal Assistance",
              ],
            },
          ]}
        /> */}
      {/* <TeamCardGrid
        subheading={<Subheading>Nuestro equipo</Subheading>}
        heading={
          <>
            Conozca nuestro equipo{" "}
            <HighlightedText>Interdisciplinario.</HighlightedText>
          </>
        }
      /> */}
      {/* <Testimonial
          subheading={<Subheading>Testimonials</Subheading>}
          heading={
            <>
              Our Clients <HighlightedText>Love Us.</HighlightedText>
            </>
          }
          testimonials={[
            {
              stars: 5,
              profileImageSrc:
                "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3.25&w=512&h=512&q=80",
              heading: "Amazing User Experience",
              quote:
                "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.",
              customerName: "Charlotte Hale",
              customerTitle: "Director, Delos Inc.",
            },
            {
              stars: 5,
              profileImageSrc:
                "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=512&h=512&q=80",
              heading: "Love the Developer Experience and Design Principles !",
              quote:
                "Sinor Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
              customerName: "Adam Cuppy",
              customerTitle: "Founder, EventsNYC",
            },
          ]}
        /> */}
      <FAQ
        subheading={<Subheading>Preguntas frecuentes</Subheading>}
        heading={
          <>
            Tienes alguna <HighlightedText>Pregunta ?</HighlightedText>
          </>
        }
        faqs={[
          // {
          //   question: "Pregunta 1 ?",
          //   answer:
          //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          // },
          // {
          //   question: "Pregunta 2 ?",
          //   answer:
          //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          // },
          // {
          //   question: "Pregunta 3 ?",
          //   answer:
          //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          // },
          // {
          //   question: "Pregunta 4 ?",
          //   answer:
          //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          // },
          // {
          //   question: "Pregunta 5 ?",
          //   answer:
          //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          // },
          {
            question: "Tengo preguntas...",
            answer:
              "Si tienes dudas puedes escribirnos a proy.ing.sw@gmail.com. Con gusto estaremos aclarando tus dudas y brindándote el soporte que necesitas :) ",
          },
        ]}
      />
      <GetStarted
        text={
          "Ya contamos con varios cursos a los que podes acceder y comenzar a entrenarte!!"
        }
      />
      <Footer />
    </AnimationRevealPage>
  );
}
